import React, { Component } from "react";
import { Checkbox, Radio, Space, Spin, message } from "antd";
import Bridge from "../../utils/Bridge";
import { logEvent } from "../../utils/analytics";

export default class GenderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: "",
      current_gender_identity: "",
      gender_identity_other_specification: "",
      race: [],
      race_other_specification: "",
      ethnicity: [],
      ethnicity_other_specification: "",
      loading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Physical sex at birth") {
                this.setState({ gender: item.value });
              }
              if (item.field == "What is your current gender identity ?") {
                this.setState({ current_gender_identity: item.value });
              }
              if (item.field == "Current Gender Identity Other Specification") {
                this.setState({
                  gender_identity_other_specification: item.value,
                });
              }
              if (item.field == "Race") {
                this.setState({ race: JSON.parse(item.value) });
              }
              if (item.field == "Race Other Specification") {
                this.setState({ race_other_specification: item.value });
              }
              if (item.field == "Ethnicity") {
                this.setState({ ethnicity: JSON.parse(item.value) });
              }
              if (item.field == "Ethnicity Other Specification") {
                this.setState({ ethnicity_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeRace = (e) => {
    let value = e.target.value;
    let tempArr = this.state.race;
    if (!tempArr.includes("Asian")) {
      tempArr = tempArr.filter((item) => item != "Asian Indian");
      tempArr = tempArr.filter((item) => item != "Chinese");
      tempArr = tempArr.filter((item) => item != "Filipino");
      tempArr = tempArr.filter((item) => item != "Japanese");
      tempArr = tempArr.filter((item) => item != "Korean");
      tempArr = tempArr.filter((item) => item != "Vietnamese");
      tempArr = tempArr.filter((item) => item != "Other Asian");
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      if (!newArray.includes("Other")) {
        this.setState({ race_other_specification: "" });
      }
      this.setState({ race: newArray });
    } else {
      tempArr.push(value);
      if (!tempArr.includes("Other")) {
        this.setState({ race_other_specification: "" });
      }
      this.setState({ race: tempArr });
    }
  };
  onChangeCurrentGender = (event) => {
    this.setState({
      current_gender_identity: event.target.value,
      gender_identity_other_specification: "",
    });
  };
  save = () => {
    if (!this.state.gender) {
      message.warning("Please select Physical sex at birth");
      return;
    }
    if (!this.state.current_gender_identity) {
      message.warning("Please select Current gender identity");
      return;
    }
    if (
      this.state.current_gender_identity == "Other" &&
      !this.state.gender_identity_other_specification
    ) {
      message.warning(
        "Please enter the specification for Current Gender Identity"
      );
      return;
    }
    if (this.state.race.length === 0) {
      message.warning("Please select Race value.");
      return;
    }
    if (
      this.state.race.includes("Other") &&
      !this.state.race_other_specification
    ) {
      message.warning("Please select Specification for Race.");
      return;
    }
    if (this.state.ethnicity.length === 0) {
      message.warning("Please select Ethnicity values");
      return;
    }
    if (
      this.state.ethnicity.includes("Other") &&
      !this.state.ethnicity_other_specification
    ) {
      message.warning("Please select Specification for Ethnicity.");
      return;
    }
    // step 2
    let questions = [
      {
        parent_field: "Physical sex at birth",
        field: "Physical sex at birth",
        value: this.state.gender,
      },
      {
        parent_field: "What is your current gender identity ?",
        field: "What is your current gender identity ?",
        value: this.state.current_gender_identity,
      },
      {
        parent_field: "Current Gender Identity Other Specification",
        field: "Current Gender Identity Other Specification",
        value: this.state.gender_identity_other_specification,
      },
      {
        parent_field: "Race",
        field: "Race",
        value: JSON.stringify(this.state.race),
      },
      {
        parent_field: "Race Other Specification",
        field: "Race Other Specification",
        value: this.state.race_other_specification,
      },
      {
        parent_field: "Ethnicity",
        field: "Ethnicity",
        value: JSON.stringify(this.state.ethnicity),
      },
      {
        parent_field: "Ethnicity Other Specification",
        field: "Ethnicity Other Specification",
        value: this.state.ethnicity_other_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "gender_info" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(3);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeEthnicity = (e) => {
    let value = e.target.value;
    let tempArr = this.state.ethnicity;
    if (!tempArr.includes("Of Hispanic, Latino/a or Spanish Origin")) {
      tempArr = tempArr.filter(
        (item) => item != "Mexican, Mexican American, Chicano/a"
      );
      tempArr = tempArr.filter((item) => item != "Puerto Rican");
      tempArr = tempArr.filter((item) => item != "Cuban");
      tempArr = tempArr.filter(
        (item) => item != "Another Hispanic, Latino/a or Spanish origin"
      );
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      // Of Hispanic, Latino/a or Spanish Origin
      if (!newArray.includes("Other")) {
        this.setState({ ethnicity_other_specification: "" });
      }
      this.setState({ ethnicity: newArray });
    } else {
      tempArr.push(value);
      if (!tempArr.includes("Other")) {
        this.setState({ ethnicity_other_specification: "" });
      }
      this.setState({ ethnicity: tempArr });
    }
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>GENDER, RACE AND ETHNICITY </h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                Physical sex at birth <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) => this.setState({ gender: e.target.value })}
                value={this.state.gender}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Male"}>Male</Radio>
                  <Radio value={"Female"}>Female</Radio>
                </Space>
              </Radio.Group>
            </div>            
            <div className="form-group">
              <label className="input-heading">
                What is your current gender identity ?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeCurrentGender}
                value={this.state.current_gender_identity}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Male"}>Male</Radio>
                  <Radio value={"Female"}>Female</Radio>
                  <Radio
                    value={"Transgender Male/Trans Man/Female-to-Male (FTM)"}
                  >
                    Transgender Male/Trans Man/Female-to-Male (FTM)
                  </Radio>
                  <Radio
                    value={
                      "Transgender Female/Trans Woman/Male-to-Female (MTF)"
                    }
                  >
                    Transgender Female/Trans Woman/Male-to-Female (MTF)
                  </Radio>
                  <Radio value={"Genderqueer/Gender Non-Conforming"}>
                    Genderqueer/Gender Non-Conforming
                  </Radio>
                  <Radio value={"Non-binary"}>Non-binary</Radio>
                  <Radio value={"Prefer not to say"}>Prefer not to say</Radio>
                  <Radio value={"Other"}>Other</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.current_gender_identity == "Other" && (
              <div className="form-group">
                <label className="input-heading">
                  Specification <span className="text-danger">*</span>{" "}
                </label>
                <br />
                <textarea
                  name="gender_identity_other_specification"
                  value={this.state.gender_identity_other_specification}
                  onChange={(e) => {
                    this.setState({
                      gender_identity_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            <div className="form-group">
              <label className="input-heading">
                Race <span className="text-danger">*</span>
                <i style={{ fontWeight: "400" }}>(select all that apply)</i>
              </label>
              <ul>
                <li>
                  <Checkbox
                    value={"American Indian or Alaska Native"}
                    onChange={this.onChangeRace}
                    checked={
                      this.state.race.includes(
                        "American Indian or Alaska Native"
                      )
                        ? true
                        : false
                    }
                  >
                    American Indian or Alaska Native
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Asian"}
                    onChange={this.onChangeRace}
                    checked={this.state.race.includes("Asian") ? true : false}
                  >
                    Asian
                  </Checkbox>
                </li>
                {this.state.race.includes("Asian") && (
                  <div style={{ paddingLeft: 45 }}>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Asian Indian")
                            ? true
                            : false
                        }
                        value={"Asian Indian"}
                        onChange={this.onChangeRace}
                      >
                        Asian Indian
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Chinese") ? true : false
                        }
                        value={"Chinese"}
                        onChange={this.onChangeRace}
                      >
                        Chinese
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Filipino") ? true : false
                        }
                        value={"Filipino"}
                        onChange={this.onChangeRace}
                      >
                        Filipino
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Japanese") ? true : false
                        }
                        value={"Japanese"}
                        onChange={this.onChangeRace}
                      >
                        Japanese
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Korean") ? true : false
                        }
                        value={"Korean"}
                        onChange={this.onChangeRace}
                      >
                        Korean
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Vietnamese") ? true : false
                        }
                        value={"Vietnamese"}
                        onChange={this.onChangeRace}
                      >
                        Vietnamese
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes("Other Asian") ? true : false
                        }
                        value={"Other Asian"}
                        onChange={this.onChangeRace}
                      >
                        Other Asian
                      </Checkbox>
                    </li>
                  </div>
                )}
                <li>
                  <Checkbox
                    value={"Black or African American"}
                    checked={
                      this.state.race.includes("Black or African American")
                        ? true
                        : false
                    }
                    onChange={this.onChangeRace}
                  >
                    Black or African American
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Native Hawaiian or Other Pacific Islander"}
                    onChange={this.onChangeRace}
                    checked={
                      this.state.race.includes(
                        "Native Hawaiian or Other Pacific Islander"
                      )
                        ? true
                        : false
                    }
                  >
                    Native Hawaiian or Other Pacific Islander
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.race.includes("White") ? true : false}
                    value={"White"}
                    onChange={this.onChangeRace}
                  >
                    White
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.race.includes("Other") ? true : false}
                    value={"Other"}
                    onChange={this.onChangeRace}
                  >
                    Other
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={
                      this.state.race.includes("Prefer not to answer")
                        ? true
                        : false
                    }
                    value={"Prefer not to answer"}
                    onChange={this.onChangeRace}
                  >
                    Prefer not to answer
                  </Checkbox>
                </li>
              </ul>
            </div>
            {this.state.race.includes("Other") && (
              <div className="form-group">
                <label className="input-heading">
                  Specification <span className="text-danger">*</span>{" "}
                </label>
                <br />
                <textarea
                  name="race_other_specification"
                  value={this.state.race_other_specification}
                  onChange={(e) => {
                    this.setState({
                      race_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            <div className="form-group">
              <label className="input-heading">
                Ethnicity <span className="text-danger">*</span>
                <i style={{ fontWeight: "400" }}>(select all that apply)</i>
              </label>
              <ul>
                <li>
                  <Checkbox
                    value={"Not of Hispanic, Latino/a or Spanish origin"}
                    onChange={this.onChangeEthnicity}
                    checked={
                      this.state.ethnicity.includes(
                        "Not of Hispanic, Latino/a or Spanish origin"
                      )
                        ? true
                        : false
                    }
                  >
                    Not of Hispanic, Latino/a or Spanish origin
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Of Hispanic, Latino/a or Spanish Origin"}
                    onChange={this.onChangeEthnicity}
                    checked={
                      this.state.ethnicity.includes(
                        "Of Hispanic, Latino/a or Spanish Origin"
                      )
                        ? true
                        : false
                    }
                  >
                    Of Hispanic, Latino/a or Spanish Origin
                  </Checkbox>
                </li>
                {this.state.ethnicity.includes(
                  "Of Hispanic, Latino/a or Spanish Origin"
                ) && (
                  <div style={{ paddingLeft: 45 }}>
                    <li>
                      <Checkbox
                        value={"Mexican, Mexican American, Chicano/a"}
                        onChange={this.onChangeEthnicity}
                        checked={
                          this.state.ethnicity.includes(
                            "Mexican, Mexican American, Chicano/a"
                          )
                            ? true
                            : false
                        }
                      >
                        Mexican, Mexican American, Chicano/a
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        value={"Puerto Rican"}
                        onChange={this.onChangeEthnicity}
                        checked={
                          this.state.ethnicity.includes("Puerto Rican")
                            ? true
                            : false
                        }
                      >
                        Puerto Rican
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.ethnicity.includes("Cuban") ? true : false
                        }
                        value={"Cuban"}
                        onChange={this.onChangeEthnicity}
                      >
                        Cuban
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.ethnicity.includes(
                            "Another Hispanic, Latino/a or Spanish origin"
                          )
                            ? true
                            : false
                        }
                        value={"Another Hispanic, Latino/a or Spanish origin"}
                        onChange={this.onChangeEthnicity}
                      >
                        Another Hispanic, Latino/a or Spanish origin
                      </Checkbox>
                    </li>
                  </div>
                )}
                <li>
                  <Checkbox
                    checked={
                      this.state.ethnicity.includes("Prefer not to answer")
                        ? true
                        : false
                    }
                    value={"Prefer not to answer"}
                    onChange={this.onChangeEthnicity}
                  >
                    Prefer not to answer
                  </Checkbox>
                </li>
              </ul>
            </div>
            {this.state.ethnicity.includes("Other") && (
              <div className="form-group">
                <label className="input-heading">
                  Specification <span className="text-danger">*</span>{" "}
                </label>
                <br />
                <textarea
                  name="ethnicity_other_specification"
                  value={this.state.ethnicity_other_specification}
                  onChange={(e) => {
                    this.setState({
                      ethnicity_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(1)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
